import React, { useState } from 'react';
import { Form, Modal, UploadFile, message } from 'antd';
import { useParams } from 'react-router-dom';
import DefaultForm from 'components/form/DefaultForm';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { RcFile } from 'antd/lib/upload/interface';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import { IVisible } from './LoadingImgTable';
import UploadMultiImage from '../resource/_component/UploadMultiImage';
import { loadingApis } from 'apis/story/loadingApis';

/**
 * * 리소스 - 미니컷 등록 모달
 */

interface IProps {
  visible: IVisible;
  setVisible: (e: any) => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
}

const LoadingImgCreate = ({
  visible,
  setVisible,
  setRefresh,
  refresh,
}: IProps) => {
  const { t } = useTranslation();
  const { projectId } = useParams();

  const [form] = Form.useForm();
  const [listImage, setListImage] = useState<UploadFile[] | []>([]);
  const [loading, setLoading] = useState(false);

  /// 서버 전송
  const handleSubmit = async () => {
    if (projectId) {
      const formData = new FormData();
      if (listImage.length > 0) {
        listImage.forEach((image, index) => {
          formData.append(`files`, image as RcFile);
        });
        try {
          setLoading(true);
          await loadingApis.loadingCreate(projectId, formData);
          setRefresh(!refresh);
          setLoading(false);
          handleClose();
        } catch (err) {
          setLoading(false);
          handleMessage(message, 'error', 'Upload failed');
        }
      }
    }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, create: false });
    setListImage([]);
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
    form.resetFields();
  };
  return (
    <CustomModal
      title='Upload Loading'
      visible={visible.create}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.upload')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <DefaultForm form={form}>
        <Form.Item name='uploadFile'>
          <UploadMultiImage
            listImage={listImage}
            setListImage={setListImage}
            requiredSubtitle={
              <ul>
                <li className='turText'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.miniCutContent.minicutRegisterModal.requiredDuplicate',
                  )}
                </li>
                <li className='turText'>{t('updateStory.form.required')}</li>
              </ul>
            }
          />
        </Form.Item>
      </DefaultForm>
    </CustomModal>
  );
};

export default LoadingImgCreate;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
